import React, { useState } from 'react'
import TableEquipments from '../../components/utils/tableEquipments'
import '../../pages/GO/go.css'
import TableBookingEquipments from './tableBookingEquipments'
import { useMediaQuery } from '@mui/material'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import GroupIcon from '@mui/icons-material/Group'
import { AirlineStopsOutlined, Anchor } from '@mui/icons-material';
import { M_CheckBox, M_InputTextField, M_Button, M_TimeLine, M_MessageBoard, M_Fieldset, M_Header } from 'src/M_Components'

export default function SimpleViewBooking({
    valueTimeline, setDefaultBooking, voyage, voyageDict, entities, entitiesDict,
    portsLocations, locationsDict, shipmentObjArray, setShipmentObjArray, bookingEquipmentArray, t, openDrawer,
    setOpenDrawer, selectedLine, setSelectedLine, changedList, drawerName, setDrawerName,
    extraValues, operation, deleteBooking, leavingPage, setLeavingPage, functionLeavingPage,
    ctx, fieldsInDrawerEquipment, fieldsInDrawerShipment, listErrors }) {

    const [open, setOpen] = useState(false)
    const [OpenModalSeeErrors, setOpenModalSeeErrors] = useState(false)
    const matches = useMediaQuery('(min-width:1600px)')

    return (
        <div style={{}}>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        {listErrors.ErrorMessage ? (
                            <M_Button
                                tooltip={t("SeeErrors")}
                                label={t("SeeErrors")}
                                icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                onClick={() => setOpenModalSeeErrors(true)}
                            />
                        ) : null}
                        {operation === 'Delete' && <M_Button
                            tooltip={t("ApproveDeletion")}
                            label={t("ApproveDeletion")}
                            icon={<img src='/icons/svgsDaNet/trash-2.svg' style={{ width: '20px', filter: 'invert(12%) sepia(97%) saturate(4989%) hue-rotate(358deg) brightness(83%) contrast(114%)' }} alt='ChangeView' />}
                            onClick={() => { setOpen(true) }}
                        />}
                    </>
                }
            />
            <div className='principalDivTimeline'>
                <div className='divTimeline'>
                    <M_TimeLine valueTimeline={valueTimeline} color={'var(--color-blue)'} />
                </div>
            </div>
            <div className='divBaseBooking'>
                <div className='divButtonSubmitBooking'>
                    <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4> <h2 style={{ margin: '0' }}>{extraValues.get('BookingNumber')}</h2>
                    </div>
                    {extraValues.get('QuoteName') && 
                        <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                            <h4 style={{ margin: '0' }}>Quote Name: &nbsp; </h4><h2 style={{ margin: '0' }}> {extraValues.get('QuoteName')}</h2>
                        </div>
                    }
                    {/* {operation === 'Delete' &&
                        <M_Button
                            tooltip={t("ApproveDeletion")}
                            hoverEffect
                            normal
                            bold
                            borderColor={'var(--color-grey)'}
                            label={t("ApproveDeletion")}
                            icon={<img src='/icons/svgsDaNet/trash-2.svg' style={{ filter: 'invert(12%) sepia(97%) saturate(4989%) hue-rotate(358deg) brightness(83%) contrast(114%)' }} alt='ChangeView' className='iconCreateBooking' />}
                            onClick={() => setOpen(true)}
                        />
                    } */}
                </div>
                <div className='menusBooking'>
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><DirectionsBoatIcon style={{ marginRight: '5px' }} /> {t("Voyage")}</span>}
                        elements={
                            <div className='divTextfieldVoyage'>
                                {voyage.map((key, index) => (
                                    <div className='textfield' key={index}>
                                        <M_InputTextField
                                            label={key.label}
                                            disabled
                                            value={voyageDict.get(key.label) || ''}
                                            secondColor={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                            color={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                        />
                                    </div>
                                ))}
                                {!matches && <div style={{ height: '62px' }}></div>}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><GroupIcon style={{ marginRight: '5px' }} /> {t("Entities")}</span>}
                        elements={
                            <div className='divTextfield'>
                                {entities.map((key, index) => (
                                    key.code === 'ClientCode' || key.code === 'ClientVAT' ?
                                        <div className='textfield' key={index}>
                                            <M_InputTextField
                                                label={key.label}
                                                disabled
                                                value={entitiesDict.get(key.label) || ''}
                                                secondColor={changedList.includes('ClientId') ? 'var(--color-yellow)' : null}
                                                color={changedList.includes('ClientId') ? 'var(--color-yellow)' : null}
                                            />
                                        </div>
                                        :
                                        key.code === 'InvoiceCode' || key.code === 'InvoiceVat' ?
                                            <div className='textfield' key={index}>
                                                <M_InputTextField
                                                    label={key.label}
                                                    disabled
                                                    value={entitiesDict.get(key.label) || ''}
                                                    secondColor={changedList.includes('InvoiceId') ? 'var(--color-yellow)' : null}
                                                    color={changedList.includes('InvoiceId') ? 'var(--color-yellow)' : null}
                                                />
                                            </div>
                                            :
                                            <div className='textfield' key={index}>
                                                <M_InputTextField
                                                    label={key.label}
                                                    disabled
                                                    value={entitiesDict.get(key.label) || ''}
                                                    secondColor={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                    color={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                />
                                            </div>
                                ))}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center', }}><Anchor style={{ marginRight: '5px' }} /> {t("Ports")}</span>}
                        elements={
                            <div className='divTextfield'>
                                {portsLocations.map((value, index) => (
                                    value.type === "textfield" ?
                                        <div key={index} className='textfield'>
                                            <M_InputTextField
                                                label={value.label}
                                                disabled
                                                value={locationsDict.get(value.label) || ''}
                                                secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                            />
                                        </div>
                                        : value.type === "checkbox" ?
                                            <div className='checkbox textfield paddingLeft' key={index}>
                                                {value.label === "Transhipment" ?
                                                    <M_CheckBox
                                                        label={value.label}
                                                        disabled
                                                        checked={locationsDict.get("Original Port") !== null ? true : false}
                                                        // secondColor={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                        color={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                    /> : <M_CheckBox />
                                                }
                                                {/* <p style={changedList.includes(value.code) ? { color: 'var(--color-yellow)' } : {}} className='textCheckbox'>{value.label}</p> */}
                                            </div>
                                            :
                                            ""
                                ))}
                            </div>
                        }
                    />
                </div >
            </div >
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center', }}><AirlineStopsOutlined style={{ marginRight: '5px' }} /> {t("Shipments")}</span>}
                elements={
                    <div className='divForm'>
                        <TableEquipments
                            value={shipmentObjArray}
                            setValue={setShipmentObjArray}
                            isView={true}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                            fieldsInDrawerShipment={fieldsInDrawerShipment}
                            fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                        />
                    </div>
                }
            />
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center', }}><i className="pi pi-box" style={{ marginRight: '10px' }}></i>  {t("Equipments")}</span>}
                elements={
                    <div className='divForm'>
                        <TableBookingEquipments
                            value={bookingEquipmentArray}
                            setValue={() => {}} 
                            isView={true}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                        />
                        <br /><br /><br /><br /><br />
                    </div>
                }
            />
            {/* <div className='divTitleEquipments stickyBaseBase'>
                {t("Equipments")}
            </div> */}
            <M_MessageBoard
                title={t('ApproveDeletion')}
                open={open}
                onClose={() => { setOpen(false) }}
                body={t('BodyConfirmDelete')}
                footer={
                    <M_Button
                        normal
                        hoverEffect
                        label={t('ButtonConfirm')}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => {
                            setOpen(false)
                            deleteBooking()
                        }}
                    />
                }
            />

            {/* MODAL SE ERRORS */}
            <M_MessageBoard
                open={OpenModalSeeErrors}
                minWidth={'30%'}
                onClose={() => setOpenModalSeeErrors(false)}
                title={t("ListErrors")}
                body={
                    <span>
                       <b>{listErrors.CreatedOn}</b>: {listErrors.ErrorMessage}
                    </span>
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                    </span>
                }
            />

            <M_MessageBoard
                warning
                open={leavingPage}
                onClose={functionLeavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBodyRead")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div>
    )
}